const entryFragment = `
  testimonialOccupation
  testimonialQuote
  testimonialImage {
    url @transform(mode: "crop", width: 2000, immediately: true)
    title
    hasFocalPoint
    focalPoint
  }
  testimonialVideo {
    url
    title
    embeddedAsset {
      url
      title
    }
  }
  testimonialBackgroundVideo {
    id
    url
    title
    embeddedAsset {
      title
      url
      providerName
    }
  }
  testimonialMobileBackgroundVideo {
    id
    url
    title
    embeddedAsset {
      title
      url
      providerName
    }
  }
`

// The blog's Matrix block has no hideReadMoreButton field (the page Matrix blocks do), so it
// can't be queried there: the blog block always shows the button.
const blockFragment = (withHideReadMore = true) => `
  id
  typeHandle
  idName
  ${withHideReadMore ? 'hideReadMoreButton' : ''}
  testimonial {
    id
    title
    typeHandle
    uri
    ... on testimonials_Entry {
      ${entryFragment}
    }
    ... on testimonialPages_Entry {
      ${entryFragment}
    }
  }
`

export const CFullWidthTestimonialFragments = {
  field: `
    fragment fullWidthTestimonial on fullWidthTestimonial_MatrixField {
      ... on fullWidthTestimonial_block_Entry {
        ${blockFragment()}
      }
    }
  `,
  field2: `
    fragment fullWidthTestimonial2 on fullWidthTestimonial2_MatrixField {
      ... on fullWidthTestimonial2_block_Entry {
        ${blockFragment()}
      }
    }
  `,
  customComponentsBlogField: `
    fragment customComponentsBlog_fullWidthTestimonial on customComponentsBlog_MatrixField {
      ... on customComponentsBlog_fullWidthTestimonial_Entry {
        ${blockFragment(false)}
      }
    }
  `,
}
